import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const formatKey = (key) => {
    const cleanedKey = key.replace(/^total_/, '');
    return cleanedKey
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
        .replace(/(\d+)/g, ' $1');
};

const FooterTotals = ({ totals }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (totals && typeof totals === 'object' && !Array.isArray(totals)) {
            const formattedData = Object.keys(totals).map((key) => ({
                name: formatKey(key),
                value: totals[key],
            }));
            setData(formattedData);
        }
    }, [totals]);

    if (data.length === 0) return null;

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" align="left" style={{ fontSize: '0.8rem' }}>
                            Total
                        </TableCell>
                        {data.map((item, index) => (
                            <TableCell
                                component="th"
                                scope="row"
                                align="left"
                                key={`${item.name}-${index}`}
                                style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                            >
                                <strong>{item.name}:</strong> {item.value}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default FooterTotals;
